"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inflateCoordinates = inflateCoordinates;
exports.inflateCoordinatesArray = inflateCoordinatesArray;
exports.inflateMultiCoordinatesArray = inflateMultiCoordinatesArray;

/**
 * @module ol/geom/flat/inflate
 */

/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {Array<import("../../coordinate.js").Coordinate>} [opt_coordinates] Coordinates.
 * @return {Array<import("../../coordinate.js").Coordinate>} Coordinates.
 */
function inflateCoordinates(flatCoordinates, offset, end, stride, opt_coordinates) {
  var coordinates = opt_coordinates !== undefined ? opt_coordinates : [];
  var i = 0;

  for (var j = offset; j < end; j += stride) {
    coordinates[i++] = flatCoordinates.slice(j, j + stride);
  }

  coordinates.length = i;
  return coordinates;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {Array<Array<import("../../coordinate.js").Coordinate>>} [opt_coordinatess] Coordinatess.
 * @return {Array<Array<import("../../coordinate.js").Coordinate>>} Coordinatess.
 */


function inflateCoordinatesArray(flatCoordinates, offset, ends, stride, opt_coordinatess) {
  var coordinatess = opt_coordinatess !== undefined ? opt_coordinatess : [];
  var i = 0;

  for (var j = 0, jj = ends.length; j < jj; ++j) {
    var end = ends[j];
    coordinatess[i++] = inflateCoordinates(flatCoordinates, offset, end, stride, coordinatess[i]);
    offset = end;
  }

  coordinatess.length = i;
  return coordinatess;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @param {Array<Array<Array<import("../../coordinate.js").Coordinate>>>} [opt_coordinatesss]
 *     Coordinatesss.
 * @return {Array<Array<Array<import("../../coordinate.js").Coordinate>>>} Coordinatesss.
 */


function inflateMultiCoordinatesArray(flatCoordinates, offset, endss, stride, opt_coordinatesss) {
  var coordinatesss = opt_coordinatesss !== undefined ? opt_coordinatesss : [];
  var i = 0;

  for (var j = 0, jj = endss.length; j < jj; ++j) {
    var ends = endss[j];
    coordinatesss[i++] = inflateCoordinatesArray(flatCoordinates, offset, ends, stride, coordinatesss[i]);
    offset = ends[ends.length - 1];
  }

  coordinatesss.length = i;
  return coordinatesss;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7Ozs7QUFJQTs7Ozs7Ozs7QUFRTSxTQUFVQSxrQkFBVixDQUNKQyxlQURJLEVBRUpDLE1BRkksRUFHSkMsR0FISSxFQUlKQyxNQUpJLEVBS0pDLGVBTEksRUFLVztFQUVmLElBQU1DLFdBQVcsR0FBR0QsZUFBZSxLQUFLRSxTQUFwQixHQUFnQ0YsZUFBaEMsR0FBa0QsRUFBdEU7RUFDQSxJQUFJRyxDQUFDLEdBQUcsQ0FBUjs7RUFDQSxLQUFLLElBQUlDLENBQUMsR0FBR1AsTUFBYixFQUFxQk8sQ0FBQyxHQUFHTixHQUF6QixFQUE4Qk0sQ0FBQyxJQUFJTCxNQUFuQyxFQUEyQztJQUN6Q0UsV0FBVyxDQUFDRSxDQUFDLEVBQUYsQ0FBWCxHQUFtQlAsZUFBZSxDQUFDUyxLQUFoQixDQUFzQkQsQ0FBdEIsRUFBeUJBLENBQUMsR0FBR0wsTUFBN0IsQ0FBbkI7RUFDRDs7RUFDREUsV0FBVyxDQUFDSyxNQUFaLEdBQXFCSCxDQUFyQjtFQUNBLE9BQU9GLFdBQVA7QUFDRDtBQUVEOzs7Ozs7Ozs7O0FBUU0sU0FBVU0sdUJBQVYsQ0FDSlgsZUFESSxFQUVKQyxNQUZJLEVBR0pXLElBSEksRUFJSlQsTUFKSSxFQUtKVSxnQkFMSSxFQUtZO0VBRWhCLElBQU1DLFlBQVksR0FBR0QsZ0JBQWdCLEtBQUtQLFNBQXJCLEdBQWlDTyxnQkFBakMsR0FBb0QsRUFBekU7RUFDQSxJQUFJTixDQUFDLEdBQUcsQ0FBUjs7RUFDQSxLQUFLLElBQUlDLENBQUMsR0FBRyxDQUFSLEVBQVdPLEVBQUUsR0FBR0gsSUFBSSxDQUFDRixNQUExQixFQUFrQ0YsQ0FBQyxHQUFHTyxFQUF0QyxFQUEwQyxFQUFFUCxDQUE1QyxFQUErQztJQUM3QyxJQUFNTixHQUFHLEdBQUdVLElBQUksQ0FBQ0osQ0FBRCxDQUFoQjtJQUNBTSxZQUFZLENBQUNQLENBQUMsRUFBRixDQUFaLEdBQW9CUixrQkFBa0IsQ0FDcENDLGVBRG9DLEVBRXBDQyxNQUZvQyxFQUdwQ0MsR0FIb0MsRUFJcENDLE1BSm9DLEVBS3BDVyxZQUFZLENBQUNQLENBQUQsQ0FMd0IsQ0FBdEM7SUFPQU4sTUFBTSxHQUFHQyxHQUFUO0VBQ0Q7O0VBQ0RZLFlBQVksQ0FBQ0osTUFBYixHQUFzQkgsQ0FBdEI7RUFDQSxPQUFPTyxZQUFQO0FBQ0Q7QUFFRDs7Ozs7Ozs7Ozs7QUFTTSxTQUFVRSw0QkFBVixDQUNKaEIsZUFESSxFQUVKQyxNQUZJLEVBR0pnQixLQUhJLEVBSUpkLE1BSkksRUFLSmUsaUJBTEksRUFLYTtFQUVqQixJQUFNQyxhQUFhLEdBQ2pCRCxpQkFBaUIsS0FBS1osU0FBdEIsR0FBa0NZLGlCQUFsQyxHQUFzRCxFQUR4RDtFQUVBLElBQUlYLENBQUMsR0FBRyxDQUFSOztFQUNBLEtBQUssSUFBSUMsQ0FBQyxHQUFHLENBQVIsRUFBV08sRUFBRSxHQUFHRSxLQUFLLENBQUNQLE1BQTNCLEVBQW1DRixDQUFDLEdBQUdPLEVBQXZDLEVBQTJDLEVBQUVQLENBQTdDLEVBQWdEO0lBQzlDLElBQU1JLElBQUksR0FBR0ssS0FBSyxDQUFDVCxDQUFELENBQWxCO0lBQ0FXLGFBQWEsQ0FBQ1osQ0FBQyxFQUFGLENBQWIsR0FBcUJJLHVCQUF1QixDQUMxQ1gsZUFEMEMsRUFFMUNDLE1BRjBDLEVBRzFDVyxJQUgwQyxFQUkxQ1QsTUFKMEMsRUFLMUNnQixhQUFhLENBQUNaLENBQUQsQ0FMNkIsQ0FBNUM7SUFPQU4sTUFBTSxHQUFHVyxJQUFJLENBQUNBLElBQUksQ0FBQ0YsTUFBTCxHQUFjLENBQWYsQ0FBYjtFQUNEOztFQUNEUyxhQUFhLENBQUNULE1BQWQsR0FBdUJILENBQXZCO0VBQ0EsT0FBT1ksYUFBUDtBQUNEIiwibmFtZXMiOlsiaW5mbGF0ZUNvb3JkaW5hdGVzIiwiZmxhdENvb3JkaW5hdGVzIiwib2Zmc2V0IiwiZW5kIiwic3RyaWRlIiwib3B0X2Nvb3JkaW5hdGVzIiwiY29vcmRpbmF0ZXMiLCJ1bmRlZmluZWQiLCJpIiwiaiIsInNsaWNlIiwibGVuZ3RoIiwiaW5mbGF0ZUNvb3JkaW5hdGVzQXJyYXkiLCJlbmRzIiwib3B0X2Nvb3JkaW5hdGVzcyIsImNvb3JkaW5hdGVzcyIsImpqIiwiaW5mbGF0ZU11bHRpQ29vcmRpbmF0ZXNBcnJheSIsImVuZHNzIiwib3B0X2Nvb3JkaW5hdGVzc3MiLCJjb29yZGluYXRlc3NzIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9nZW9tL2ZsYXQvaW5mbGF0ZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==